export const STOCK_RESERVATION = 'StockReservation';
export const StockReservationStatusValues = [
    'open',
    'consumed',
    'released',
];
export const STOCK_RESERVATION_STATUS_LABELS = {
    open: 'Aberta',
    consumed: 'Consumida',
    released: 'Liberada',
};
//# sourceMappingURL=stock-reservation.js.map